import { IAuthActions } from "../../action-types/auth/IAuthActions";
import { IAuthReducer } from "../../reducer-model/auth/IAuthReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initialState: IAuthReducer = {
    status: eReducerStatusBase.is_not_initialization,
    user: null,
    access_token: null,
    error_message: "",
};

export const authReducer = (state: IAuthReducer = initialState, action: IAuthActions): IAuthReducer => {
    switch (action.type) {
        case "AUTH_LOGIN_START":
            return { ...state, status: eReducerStatusBase.is_loading, error_message: "" };
        case "AUTH_LOGIN_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                user: action.payload.user,
                access_token: action.payload.access_token,
                error_message: "",
            };
        case "AUTH_RESTORE_SESSION":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                user: action.payload.user,
                access_token: action.payload.access_token,
            };
        case "AUTH_LOGIN_ERROR":
            return { ...state, status: eReducerStatusBase.is_error, error_message: action.payload };
        case "AUTH_LOGOUT":
            return { ...initialState };
        default:
            return state;
    }
};
